import type { components } from "@/api/schema";

type Stock = components["schemas"]["Stock"];

const COLUMNS: (keyof Stock)[] = [
  "sku",
  "product_name",
  "marketplace",
  "on_hand",
  "fake",
  "lock",
  "reserve",
  "sellable",
  "multiplier",
  "status_code",
];

function escapeCsv(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function stockToCsv(items: Stock[]): string {
  const header = COLUMNS.join(",");
  const rows = items.map((item) => COLUMNS.map((col) => escapeCsv(item[col])).join(","));
  return [header, ...rows].join("\n");
}

/** Triggers a browser download of the CSV text. */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
